document.addEventListener("DOMContentLoaded", function () {
    // Add to Watchlist Button (Right Panel)
    document.addEventListener('click', function(e) {
        const addToWatchlistBtn = e.target.closest('.add-to-watchlist');
        if (addToWatchlistBtn && (addToWatchlistBtn.closest('#right-container') || addToWatchlistBtn.closest('#center-chart-overlay'))) {

            // Check login status
            let isLoggedIn = false;
            try {
                const sessionStr = localStorage.getItem('auth_session');
                if (sessionStr) {
                    const sessionItem = JSON.parse(sessionStr);
                    if (sessionItem && sessionItem.expiry && Date.now() < sessionItem.expiry) {
                        isLoggedIn = true;
                    }
                }
            } catch (e) {
                console.error('Error checking login status', e);
            }

            if (!isLoggedIn) {
                const message = 'Log in to access watchlist';
                if (window.WatchlistApp && window.WatchlistApp.Popup && window.WatchlistApp.Popup.showNotificationPopup) {
                    window.WatchlistApp.Popup.showNotificationPopup('Watchlist Access', message);
                } else {
                    alert(message);
                }
                return;
            }

            let ticker = null;
            let company = null;

            // 1. Try extracting from right-panel-data-handler component (Primary source of truth)
            if (!ticker) {
                const handlerEl = document.querySelector('[right-panel-data-handler]');
                if (handlerEl && handlerEl.components && handlerEl.components['right-panel-data-handler']) {
                    const data = handlerEl.components['right-panel-data-handler'].data;
                    if (data && data.ticker) {
                        ticker = data.ticker;
                        // company might not be in data, but that's optional
                    } else if (handlerEl.components['right-panel-data-handler'].currentTicker) {
                        ticker = handlerEl.components['right-panel-data-handler'].currentTicker;
                    }
                }
            }

            // 2. Try extracting from stock-chart component
            if (!ticker) {
                const stockChart = document.getElementById('stock-chart');
                if (stockChart && stockChart.hasAttribute('tradingview-universal-chart')) {
                    const attr = stockChart.getAttribute('tradingview-universal-chart');
                    // It might be a string or object depending on A-Frame version/state
                    let chartData = attr;
                    if (typeof attr === 'string') {
                        try {
                        } catch (e) {}
                    }

                    if (chartData && chartData.stockData) {
                        try {
                            const stockData = typeof chartData.stockData === 'string' ? JSON.parse(chartData.stockData) : chartData.stockData;
                            if (stockData.ticker) ticker = stockData.ticker;
                            if (!company && stockData.tickerDetails && stockData.tickerDetails.name) company = stockData.tickerDetails.name;
                        } catch(e) {
                            console.warn('Error parsing stockData from chart', e);
                        }
                    }
                }
            }

            // 3. Try extracting from Profile DOM (Fallback)
            if (!ticker) {
                const tickerEl = document.querySelector('.short-form .row.ticker .value') ||
                    document.querySelector('.full-form .row.ticker .item.value') ||
                    document.querySelector('.hover-pop-up .short-form .row.ticker .value');
                if (tickerEl) ticker = tickerEl.textContent.trim();
            }

            // Extract company name if not found from chart
            if (!company) {
                const companyEl = document.querySelector('.full-form .full-name h4');
                if (companyEl) company = companyEl.textContent.trim();
            }

            // 4. Fallback Global variable if exists (from search-handler?)
            // Not implemented as no obvious global found.

            if (ticker && window.WatchlistApp && window.WatchlistApp.Popup && window.WatchlistApp.Popup.showAddToWatchlistPopup) {
                window.WatchlistApp.Popup.showAddToWatchlistPopup(ticker, company);
            } else {
                console.error('Add to Watchlist failed: Ticker not found or Popup module missing. Ticker:', ticker);
                if (!ticker) alert('Please select a stock first.');
            }
            
            if (window.gtag) gtag('event', `Desktop_RightPanel_AddWatchlistButton`);
        }
    });
});
